<template>
    <!-- <ul class="list"></ul> -->

    <component :is="layout">
      <nav class="navbar navbar-top navbar-expand-md navbar-dark" id="navbar-main">
        <div class="container-fluid">
          <a class="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block" href="#">
            <i class="fas fa-home"></i> {{ $i18n.t('global.dashboard') }}
          </a>

          <!-- <form class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
            <div class="form-group mb-0">
              <div class="input-group input-group-alternative">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fas fa-search"></i></span>
                </div>
                <input class="form-control" placeholder="Search" type="text">
              </div>
            </div>
          </form> -->

          <!-- <ul class="navbar-nav align-items-center d-none d-md-flex" v-if="user">
            <li class="nav-item dropdown">
              <a class="nav-link pr-0" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <div class="media align-items-center">
                  <div class="media-body ml-2 d-none d-lg-block">
                    <span class="mb-0 text-sm  font-weight-bold">{{ user.displayName }}</span>
                  </div>
                </div>
              </a>
              <div class="dropdown-menu dropdown-menu-arrow dropdown-menu-right">
                <div class=" dropdown-header noti-title">
                  <h6 class="text-overflow m-0">Welcome!</h6>
                </div>
                <a href="./examples/profile.html" class="dropdown-item">
                  <i class="ni ni-single-02"></i>
                  <span>My profile</span>
                </a>
                <a href="./examples/profile.html" class="dropdown-item">
                  <i class="ni ni-settings-gear-65"></i>
                  <span>Settings</span>
                </a>
                <a href="./examples/profile.html" class="dropdown-item">
                  <i class="ni ni-calendar-grid-58"></i>
                  <span>Activity</span>
                </a>
                <a href="./examples/profile.html" class="dropdown-item">
                  <i class="ni ni-support-16"></i>
                  <span>Support</span>
                </a>
                <div class="dropdown-divider"></div>
                <a href="#!" class="dropdown-item">
                  <i class="ni ni-user-run"></i>
                  <span>Logout</span>
                </a>
              </div>
            </li>
          </ul> -->

          <ul class="navbar-nav align-items-center d-none d-md-flex">
            <li class="nav-item dropdown">
              <a class="nav-link pr-0" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <div class="media align-items-center">
                  <span v-if="user" class="photoURL avatar avatar-sm rounded-circle" :style="{ 'background-image': 'url('+user.photoURL+')' }">
                  </span>
                  <div class="media-body ml-2 d-none d-lg-block">
                    <span class="mb-0 text-sm  font-weight-bold">{{ user ? user.displayName : '' }}</span>
                  </div>
                </div>
              </a>
              <div class="dropdown-menu dropdown-menu-arrow dropdown-menu-right">
                <Menu key="Dashboard" />
              </div>
            </li>
          </ul>

        </div>
      </nav>

      <div class="header bg-gradient-primary pb-6 pt-5 pt-md-8">
        <div class="container-fluid">
          <div class="header-body">
            <!-- Card stats -->
            <div class="row">
              <div class="col-xl-4 col-lg-4">
                <div class="card card-stats mb-4 mb-xl-0">
                  <div class="card-body btn-hover" @click="$router.replace({ name: 'coin' })">
                    <div class="row">
                      <div class="col">
                        <h5 class="card-title text-uppercase text-muted mb-0">{{ $i18n.t('global.coins') }}</h5>
                        <span class="h2 font-weight-bold mb-0">
                          <span v-if="coinsCount !== null">{{ coinsCount }}</span>
                          <span v-else><img src="../../static/img/loading.gif" alt="Loading" width="25"></span>
                        </span>
                      </div>
                      <div class="col-auto">
                        <div class="icon icon-shape bg-danger text-white rounded-circle shadow">
                          <i class="fas fa-coins"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4">
                <div class="card card-stats mb-4 mb-xl-0">
                  <div class="card-body btn-hover" @click="$router.replace({ name: 'banknote' })">
                    <div class="row">
                      <div class="col">
                        <h5 class="card-title text-uppercase text-muted mb-0">{{ $i18n.t('global.banknotes') }}</h5>
                        <span class="h2 font-weight-bold mb-0">
                          <span v-if="banknotesCount !== null">{{ banknotesCount }}</span>
                          <span v-else><img src="../../static/img/loading.gif" alt="Loading" width="25"></span>
                        </span>
                      </div>
                      <div class="col-auto">
                        <div class="icon icon-shape bg-warning text-white rounded-circle shadow">
                          <i class="far fa-money-bill-alt"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4">
                <div class="card card-stats mb-4 mb-xl-0">
                  <div class="card-body btn-hover" @click="$router.replace({ name: 'book' })">
                    <div class="row">
                      <div class="col">
                        <h5 class="card-title text-uppercase text-muted mb-0">{{ $i18n.t('global.books') }}</h5>
                        <span class="h2 font-weight-bold mb-0">
                          <span>{{ books ? books.length : 0 }}</span>
                        </span>
                      </div>
                      <div class="col-auto">
                        <div class="icon icon-shape bg-yellow text-white rounded-circle shadow">
                          <i class="fas fa-book"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid mt--7">

        <div class="row mt-5">
          <div class="col">
            <div class="card shadow">
              <!-- <div class="card-header border-0">
                <h3 class="mb-0">{{ $i18n.t('dashboard.map') }}</h3>
              </div> -->
              <!-- <div class="map" ref="chartdiv"></div> -->
              <div v-if="coinsBanknotesByContinent" id="listMap">
                <div class="table-responsive">
                  <table class="table align-items-center table-flush">
                    <tbody>
                      <tr v-for="(continent, index) in coinsBanknotesByContinent" :key="index">
                        <th scope="row">{{ $i18n.t('continents.'+continent.id) }}</th>
                        <td>
                          <button type="button" style="color:white" :style="{'background-color': continent.color}" class="btn full-width" @click.prevent="goToCoinsContinent(continent.id)">
                            {{ continent.nbCoins }} <i class="fas fa-coins"></i>
                          </button>
                        </td>
                        <td>
                          <button type="button" style="color:white" :style="{'background-color': continent.color}" class="btn full-width" @click.prevent="goToBanknotesContinent(continent.id)">
                            {{ continent.nbBanknotes }} <i class="far fa-money-bill-alt"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-else class="text-center mt-5 mb-5">
                <img src="../../static/img/loading.gif" alt="Loading" width="75">
              </div>
            </div>
          </div>
        </div>

        <Footer />
        <!-- <router-link class="nav-link" to="/login" @click.native="logout" replace>Logout</router-link> -->
      </div>
    </component>

</template>

<script>
import Footer from '../layouts/Footer'
import Menu from '../layouts/Menu'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4maps from '@amcharts/amcharts4/maps'
import am4themesAnimated from '@amcharts/amcharts4/themes/animated'
import am4GeodataWorldLow from '@amcharts/amcharts4-geodata/worldLow'

am4core.useTheme(am4themesAnimated)

export default {
  name: 'Dashboard',
  components: { Footer, Menu },
  data () {
    return {
      amcharts: []
    }
  },
  computed: {
    layout () {
      /* if (!this.$store.getters.user || !localStorage.getItem('user')) {
        this.$router.replace({ name: 'login' })
      } */
      return 'Layout'
    },
    banknotesCount () {
      return this.$store.getters.banknotesCount
    },
    coinsCount () {
      return this.$store.getters.coinsCount
    },
    coinsBanknotesByContinent () {
      return this.$store.getters.coinsBanknotesByContinent
    },
    // countriesAmcharts () {
    //   return this.$store.getters.countriesAmcharts
    // },
    books () {
      return this.$store.getters.books
    },
    user () {
      return this.$store.getters.user
    }
  },
  created () {
    this.$store.dispatch('fetchUser')
    this.$store.dispatch('fetchBooks')
    // this.$store.dispatch('fetchCountriesAmcharts')
    this.$store.dispatch('fetchCountries')
    this.$store.dispatch('fetchCoinsCount')
    this.$store.dispatch('fetchBanknotesCount')
    this.$store.dispatch('fetchCoinsBanknotesByContinent')
  },
  mounted () {
    // this.initAmcharts()
  },
  beforeDestroy () {
    if (this.chart2) {
      this.chart2.dispose()
    }
  },
  methods: {
    goToCoinsContinent (codeContinent) {
      this.$router.replace({ name: 'coin.continent', params: { code: codeContinent.toLowerCase() } })
    },
    goToBanknotesContinent (codeContinent) {
      this.$router.replace({ name: 'banknote.continent', params: { code: codeContinent.toLowerCase() } })
    },
    logout () {
      this.$parent.logout()
    },
    initAmcharts () {
      // create map
      let chart2 = am4core.create(this.$refs.chartdiv, am4maps.MapChart)
      chart2.geodata = am4GeodataWorldLow
      chart2.projection = new am4maps.projections.Miller()

      // polygons
      let polygonSeries = chart2.series.push(new am4maps.MapPolygonSeries())
      polygonSeries.useGeodata = true
      // polygonSeries.mapPolygons.template.events.on('hit', ev => {
      //   chart2.zoomToMapObject(ev.target)
      //   console.log('click map', ev.target, ev)
      // })

      // template
      // let polygonTemplate = polygonSeries.mapPolygons.template
      // polygonTemplate.tooltipText = '{name}'
      // polygonTemplate.data = this.$store.getters.countriesAmcharts

      // polygonTemplate.fill = am4core.color('#5e72e4')
      // let hs = polygonTemplate.states.create('hover')
      // hs.properties.fill = am4core.color('#172b4d')
    }
  }
}
</script>

<style scoped>
@media screen and (max-width: 600px) {
  .map { display: none; }
}
.map {
  width: 100%;
  height: 500px;
}
[scope='col'], .btn-hover:hover {
  cursor: pointer;
}

.modal-dialog {
  max-width: 100%;
  margin: 1.75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue